<template>
  <div class="flex flex-col gap-4 items-center p-4 justify-center">
    <transition name="fade" mode="out-in">
      <div
        v-if="notAnsweredQuestions.length === 0"
        key="allDone"
        class="flex flex-col gap-4 items-center p-4"
      >
        <span class="text-5xl md:text-7xl">👑</span>
        <p class="text-2xl md:text-3xl font-semibold text-center">
          {{ $t("requestTender.terms.title") }}
        </p>
        <p class="font-semibold text-center">
          {{ $t("requestTender.terms.subtitle_1") }}
          <br />
          {{ $t("requestTender.terms.subtitle_2") }}
        </p>
        <NuxtLink
          target="_blank"
          :to="localePath({ name: 'documentsIndexPage' })"
          class="text-center"
        >
          {{ $t("requestTender.terms.termsLink") }}
        </NuxtLink>

        <JoszakiButton
          class="mt-4"
          type="success"
          size="xl"
          icon-left="rocket"
          :loading="loading"
          @click="$emit('submit')"
          @keyup.enter.exact.native="$emit('submit')"
        >
          {{ $t("requestTender.terms.acceptCta") }}
        </JoszakiButton>
      </div>
      <div
        v-else
        key="remainingQuestions"
        class="lastStep-unansweredQuestionList"
      >
        <div class="text-2xl md:text-3xl font-semibold text-center mb-6">
          😌 {{ $t("requestTender.unanswered.title") }}
        </div>
        <div class="md:text-2xl font-semibold text-center mb-6">
          {{ $t("requestTender.unanswered.subtitle") }}
        </div>
        <JoszakiCard
          v-for="question in notAnsweredQuestions"
          :key="`${question.slug || question.fieldName}_notAnsweredQuestion`"
          class="flex flex-row gap-2 items-center justify-between mb-4"
        >
          <div>
            <span class="font-bold">
              {{ question.index }}.
              <IconComponent icon="long-arrow-alt-right" class="inline" />
            </span>
            <template v-if="question.isCustom">
              {{ question.label || question.slug }}
            </template>
            <template v-else>
              {{ $t(`requestTender.${question.fieldName}.question`) }}
            </template>
          </div>
          <JoszakiButton
            type="info"
            @click="$emit('goto-step', question.index)"
          >
            {{ $t("requestTender.unanswered.answerCta") }}
          </JoszakiButton>
        </JoszakiCard>
      </div>
    </transition>
  </div>
</template>

<script>
import { useNewTender } from "~/composables/tender/useNewTender";

export default {
  name: "TermsStepModule",
  props: {
    currentStep: { type: Number, required: true },
    totalSteps: { type: Number, required: true },
    loading: { type: Boolean, default: false },
    /**
     * Array describing every visible step before terms, in their resolved
     * order. Each entry is { index, fieldName }.
     */
    stepDescriptors: {
      type: Array,
      required: true,
    },
  },
  emits: ["submit", "goto-step"],
  setup() {
    return { newTender: useNewTender() };
  },
  computed: {
    notAnsweredQuestions() {
      const list = [];
      const answers = this.newTender.moduleAnswers.value || {};
      for (const desc of this.stepDescriptors) {
        if (desc.fieldName === "terms" || desc.fieldName === "phone") continue;
        if (desc.isCustom) {
          const snap = answers[desc.slug];
          const a = snap?.answer;
          const filled = Array.isArray(a)
            ? a.length > 0
            : typeof a === "string" && a.trim().length > 0;
          if (!filled) list.push(desc);
          continue;
        }
        const value = this.newTender[desc.fieldName]?.value;
        if (!value) list.push(desc);
      }
      const phoneStep = this.stepDescriptors.find(
        (d) => d.fieldName === "phone"
      );
      if (phoneStep && !this.newTender.phone.value?.number) {
        list.push(phoneStep);
      }
      return list;
    },
  },
};
</script>
